import moment from 'moment'

export default function humanWeek(value) {
    return (moment(value).format('WW'))
}
